import {
  BENEFIT_LIST_MENU,
  EMPLOYEE_BENEFIT_MENU,
  EMPLOYEE_LIST_MENU,
  PLAN_LIST_MENU,
  POLICY_LIST_MENU,
} from "../../constants/menu.constant";

import { Menu, SideBarMenu } from "@/shared/models/menu.model";

import { EmployeeBenefitPermissionList } from "@/src/employee-benefit/permission";

export function useEmployeeBenefitMenu(
  menus: SideBarMenu[],
  permission: EmployeeBenefitPermissionList,
): SideBarMenu[] {
  let sideBarMenus: SideBarMenu[];

  function isShowEmployeeBenefitMenu(): boolean {
    return (
      permission.isAbleToShowParticipantDetail() ||
      permission.isAbleToShowPlanDetail() ||
      permission.isAbleToShowPolicyDetail() ||
      permission.isAbleToShowBenefitDetail()
    );
  }

  function insertMenuAfterDashboard(
    newSideBarMenus: SideBarMenu[],
    employeeBenefitMenu: SideBarMenu,
  ): SideBarMenu[] {
    const dashboardMenuIndex = newSideBarMenus.findIndex(
      (sideBarMenu: SideBarMenu) => sideBarMenu.isMainDashboard,
    );

    newSideBarMenus.splice(dashboardMenuIndex + 1, 0, employeeBenefitMenu);
    return newSideBarMenus;
  }

  function getEmployeeBenefitMenu(): SideBarMenu {
    const employeeBenefitMenu = EMPLOYEE_BENEFIT_MENU;

    if (permission.isAbleToShowParticipantDetail()) {
      !menuHasInserted(employeeBenefitMenu, EMPLOYEE_LIST_MENU) &&
        employeeBenefitMenu.items?.push(EMPLOYEE_LIST_MENU);
    }

    if (permission.isAbleToShowPlanDetail()) {
      !menuHasInserted(employeeBenefitMenu, PLAN_LIST_MENU) &&
        employeeBenefitMenu.items?.push(PLAN_LIST_MENU);
    }

    if (permission.isAbleToShowPolicyDetail()) {
      !menuHasInserted(employeeBenefitMenu, POLICY_LIST_MENU) &&
        employeeBenefitMenu.items?.push(POLICY_LIST_MENU);
    }

    // if (permission.isBenefitList) {
    //   !menuHasInserted(employeeBenefitMenu, BENEFIT_LIST_MENU) &&
    //     employeeBenefitMenu.items?.push(BENEFIT_LIST_MENU);
    // }

    return employeeBenefitMenu;
  }

  function menuHasInserted(menu: SideBarMenu, menuItem: Menu): boolean {
    const selectedMenu = menu.items?.find((item: Menu) => {
      return item.name === menuItem.name;
    });

    return !!selectedMenu;
  }

  function transformSuperAdminMenus(): SideBarMenu[] {
    const transformedMenus = menus.map((menu: SideBarMenu): SideBarMenu => {
      const isEmployeeBenefit = menu.name === "employee-benefit";

      if (!isEmployeeBenefit) return menu;

      return {
        ...menu,
        items: [EMPLOYEE_LIST_MENU, PLAN_LIST_MENU, POLICY_LIST_MENU],
      };
    });

    return transformedMenus;
  }

  (function handleSideBarMenu(): void {
    if (permission.isSuperAdmin()) {
      sideBarMenus = transformSuperAdminMenus();
      return;
    }

    if (!isShowEmployeeBenefitMenu()) {
      sideBarMenus = menus;
      return;
    }

    sideBarMenus = insertMenuAfterDashboard(
      [...menus],
      getEmployeeBenefitMenu(),
    );
  })();

  return sideBarMenus;
}
